import PropTypes from 'prop-types';
import React from 'react';

const FunctionBadges = ({ teamFunctions, maxDisplay = 3 }) => {
  const functions = teamFunctions || [];

  if (functions.length === 0) {
    return <span className="team-role-text">—</span>;
  }

  const displayed = functions.slice(0, maxDisplay);
  const remaining = functions.length - displayed.length;

  return (
    <div className="team-function-badges">
      {displayed.map((fn) => (
        <span key={fn.id} className="team-function-badge">
          {fn.name}
        </span>
      ))}
      {remaining > 0 && (
        <span className="team-function-more-badge">+{remaining} more</span>
      )}
    </div>
  );
};

FunctionBadges.propTypes = {
  teamFunctions: PropTypes.array,
  maxDisplay: PropTypes.number,
};

export default FunctionBadges;
